/**
 * 今日到店车两信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 车辆信息
Mock.mock(/carsb\/\d+\/prepaid_orders/, 'post' + mockSwitch, {
  'code': 0,
  'data': {
    'prepaid_order': {
      'status': 'pending_review'
    }
  },
  'message': 'ok'
})

Mock.mock(/carsa\/\d+\/prepaid_coupon_batches/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'coupon_batches': [{
      // 'category': 'free',
      'coupon_batch_id': 4,
      'face_value': 45455,
      'title': '他呵呵哈个人人'
    }],
    'max_batch_count': 1,
    'total_count': 1
  },
  'message': 'ok'
})

Mock.mock(/carsa\/\d+\/users/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'users': [{
      'is_subscriber': true,
      'mobile_number': '15818758029',
      'name': 'gary',
      'user_id': 14
    }]
  },
  'message': 'ok'
})
